module.exports = __webpack_public_path__ + "static/media/Lens_Card_CN.483b6874.png";